import { Injectable } from '@angular/core';

const THEME_KEY = 'preferred-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private doc = document.documentElement;

  init() {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored) {
      this.applyTheme(stored as 'light' | 'dark');
      return;
    }

    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)',
    ).matches;
    if (prefersDark) {
      this.applyTheme('dark');
    } else {
      this.clearExplicitTheme();
    }
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', (e) => {
        if (!localStorage.getItem(THEME_KEY)) {
          if (e.matches) {
            this.applyTheme('dark');
          } else {
            this.clearExplicitTheme();
          }
        }
      });
  }

  toggle() {
    const current =
      this.doc.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    const next = current === 'dark' ? 'light' : 'dark';
    this.applyTheme(next);
    localStorage.setItem(THEME_KEY, next);
  }

  applyTheme(theme: 'light' | 'dark') {
    this.doc.setAttribute('data-theme', theme);
    this.updateThemeColor(theme);
  }

  private updateThemeColor(theme: 'light' | 'dark') {
    const themeColor = theme === 'dark' ? '#121417' : '#ffffff';
    let metaTag = document.querySelector(
      'meta[name="theme-color"]:not([media])',
    );

    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', 'theme-color');
      document.head.appendChild(metaTag);
    }

    metaTag.setAttribute('content', themeColor);
  }

  clearExplicitTheme() {
    this.doc.removeAttribute('data-theme');
    localStorage.removeItem(THEME_KEY);
    // Reset theme-color based on system preference
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)',
    ).matches;
    this.updateThemeColor(prefersDark ? 'dark' : 'light');
  }

  setThemeExplicit(theme: 'light' | 'dark') {
    this.applyTheme(theme);
    localStorage.setItem(THEME_KEY, theme);
  }
}
